import React from 'react';
import { PlusCircle, UserCheck, Key, Users, Image, BarChart } from 'lucide-react';

const AdditionalFeaturesSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  if (!formData.includeAdditionalFeatures) {
    return (
      <div className="mb-6">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="includeAdditionalFeatures"
            checked={formData.includeAdditionalFeatures}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
            <PlusCircle className="w-4 h-4 mr-1 text-indigo-500" />
            Включить дополнительные функции
          </span>
        </label>
      </div>
    );
  }

  return (
    <div className="mb-6 bg-indigo-50 dark:bg-indigo-900/20 p-4 rounded-lg border border-indigo-200 dark:border-indigo-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <PlusCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Дополнительная функциональность
      </h3>

      <div className="space-y-3">
        <label className="flex items-start p-3 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-indigo-100/40 dark:hover:bg-indigo-900/40 transition-colors">
          <input
            type="checkbox"
            name="featuresKYC"
            checked={formData.featuresKYC}
            onChange={handleInputChange}
            className="form-checkbox mt-0.5"
          />
          <div className="ml-2">
            <span className="block text-sm font-medium text-gray-900 dark:text-white flex items-center">
              <UserCheck className="w-4 h-4 mr-1 text-indigo-500" />
              KYC / Верификация пользователей
            </span>
            <span className="text-xs text-gray-500 dark:text-gray-400">
              Включает интеграцию с системами идентификации и верификации пользователей, соответствие AML/KYC регулированию
            </span>
          </div>
        </label>

        <label className="flex items-start p-3 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-indigo-100/40 dark:hover:bg-indigo-900/40 transition-colors">
          <input
            type="checkbox"
            name="featuresMultiSig"
            checked={formData.featuresMultiSig}
            onChange={handleInputChange}
            className="form-checkbox mt-0.5"
          />
          <div className="ml-2">
            <span className="block text-sm font-medium text-gray-900 dark:text-white flex items-center">
              <Key className="w-4 h-4 mr-1 text-indigo-500" />
              Мультиподпись (MultiSig)
            </span>
            <span className="text-xs text-gray-500 dark:text-gray-400">
              Функционал для транзакций, требующих подтверждения несколькими ключами, повышенная безопасность
            </span>
          </div>
        </label>

        <label className="flex items-start p-3 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-indigo-100/40 dark:hover:bg-indigo-900/40 transition-colors">
          <input
            type="checkbox"
            name="featuresDAO"
            checked={formData.featuresDAO}
            onChange={handleInputChange}
            className="form-checkbox mt-0.5"
          />
          <div className="ml-2">
            <span className="block text-sm font-medium text-gray-900 dark:text-white flex items-center">
              <Users className="w-4 h-4 mr-1 text-indigo-500" />
              Функциональность DAO
            </span>
            <span className="text-xs text-gray-500 dark:text-gray-400">
              Децентрализованная автономная организация с голосованием, токенизированным управлением и автоматизированными решениями
            </span>
          </div>
        </label>

        <label className="flex items-start p-3 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-indigo-100/40 dark:hover:bg-indigo-900/40 transition-colors">
          <input
            type="checkbox"
            name="featuresNFT"
            checked={formData.featuresNFT}
            onChange={handleInputChange}
            className="form-checkbox mt-0.5"
          />
          <div className="ml-2">
            <span className="block text-sm font-medium text-gray-900 dark:text-white flex items-center">
              <Image className="w-4 h-4 mr-1 text-indigo-500" />
              Функциональность NFT
            </span>
            <span className="text-xs text-gray-500 dark:text-gray-400">
              Создание, выпуск и управление невзаимозаменяемыми токенами, включая метаданные и хранение
            </span>
          </div>
        </label>

        <label className="flex items-start p-3 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-indigo-100/40 dark:hover:bg-indigo-900/40 transition-colors">
          <input
            type="checkbox"
            name="featuresDEX"
            checked={formData.featuresDEX}
            onChange={handleInputChange}
            className="form-checkbox mt-0.5"
          />
          <div className="ml-2">
            <span className="block text-sm font-medium text-gray-900 dark:text-white flex items-center">
              <BarChart className="w-4 h-4 mr-1 text-indigo-500" />
              Функциональность DEX
            </span>
            <span className="text-xs text-gray-500 dark:text-gray-400">
              Децентрализованный обмен токенами, функции ликвидности, свопы, пулы и ценообразование
            </span>
          </div>
        </label>
      </div>

      <div className="mt-4 flex items-center justify-between">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="includeAdditionalFeatures"
            checked={formData.includeAdditionalFeatures}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Включить дополнительные функции
          </span>
        </label>
      </div>
    </div>
  );
};

export default AdditionalFeaturesSection;